import React from 'react';
import { RefreshCw, Target, Users, Shield } from 'lucide-react';
import PageHeader from '../components/PageHeader';

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <PageHeader />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* Hero Section */}
        <div className="text-center">
          <h1 className="text-4xl font-extrabold text-gray-900 sm:text-5xl sm:tracking-tight lg:text-6xl">
            About 4D EMR Integration Platform
          </h1>
          <p className="mt-6 max-w-2xl mx-auto text-xl text-gray-500">
            Bridging the gap between healthcare systems with secure, seamless EMR integration solutions.
          </p>
        </div>

        {/* Values Section */}
        <div className="mt-20">
          <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
            <div className="text-center">
              <div className="flex items-center justify-center h-12 w-12 rounded-md bg-indigo-600 text-white mx-auto">
                <Target className="h-6 w-6" />
              </div>
              <h3 className="mt-6 text-lg font-medium text-gray-900">Our Mission</h3>
              <p className="mt-2 text-base text-gray-500">
                To revolutionize healthcare data management by providing seamless integration between EMR systems and leading CRM platforms.
              </p>
            </div>

            <div className="text-center">
              <div className="flex items-center justify-center h-12 w-12 rounded-md bg-indigo-600 text-white mx-auto">
                <Users className="h-6 w-6" />
              </div>
              <h3 className="mt-6 text-lg font-medium text-gray-900">Our Team</h3>
              <p className="mt-2 text-base text-gray-500">
                Healthcare technology experts dedicated to improving patient care through advanced EMR integration solutions and data synchronization.
              </p>
            </div>

            <div className="text-center">
              <div className="flex items-center justify-center h-12 w-12 rounded-md bg-indigo-600 text-white mx-auto">
                <Shield className="h-6 w-6" />
              </div>
              <h3 className="mt-6 text-lg font-medium text-gray-900">Our Values</h3>
              <p className="mt-2 text-base text-gray-500">
                Committed to HIPAA compliance, data security, and continuous innovation in healthcare technology integration.
              </p>
            </div>
          </div>
        </div>

        {/* Story Section */}
        <div className="mt-20">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-3xl font-extrabold text-gray-900">Our Story</h2>
            <p className="mt-4 text-lg text-gray-500">
              Founded in 2024, our 4D EMR Integration Platform emerged from a critical need in healthcare: seamless data synchronization between EMR systems and CRM platforms. What began as a specialized solution for medical practices has evolved into a comprehensive healthcare data integration platform trusted by healthcare providers nationwide.
            </p>
          </div>
        </div>

        {/* Stats Section */}
        <div className="mt-20">
          <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
            <div className="text-center">
              <div className="text-4xl font-extrabold text-indigo-600">1000+</div>
              <div className="mt-2 text-lg font-medium text-gray-900">Healthcare Providers</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-extrabold text-indigo-600">50k+</div>
              <div className="mt-2 text-lg font-medium text-gray-900">Patient Records Synced</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-extrabold text-indigo-600">98%</div>
              <div className="mt-2 text-lg font-medium text-gray-900">Data Accuracy Rate</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}